<div class="flex flex-col gap-3 p-4">
  <p class="text-sm">To add a template, open a board’s More menu (⋯) and choose Save as template.</p>
  @if (loading()) { <p role="status">Loading…</p> }
  @for (template of templates(); track template.id) {
    <app-button2 [disabled]="busy()" (click)="choose(template)">{{ template.title }}</app-button2>
  } @empty {
    @if (!loading() && !error()) { <p>No templates yet.</p> }
  }
  @if (error()) { <p role="alert">{{ error() }}</p> }
</div>
